window.arReactionDetailFormatter = function(value, row) {
    let html = '';
    if (row.motivation) {
        html += '<span class="fw-bold">'+__('Motivation')+'</span>';
        html += '<p>'+row.motivation+'</p>';
    }
    if (row.comments) {
        html += '<span class="fw-bold">'+__('Comments')+'</span>';
        html += '<p>'+row.comments+'</p>';
    }
    return html;
};

